import styled from 'styled-components';

import TickIcon from '../../../../Icons/TickIcon';
import FreeCancelIcon from '../../../../Icons/FreeCancelIcon';

export const InclusionWrapOuterDiv = styled.div(
  props => `
    display:flex;
    flex-wrap: wrap;
    flex-direction: column;
    width:100%;
  `
);

export const InclusionTxtDiv = styled.div(
  props => `
    display:flex;
    flex-wrap: wrap;
    flex-direction: column;
    width:100%;
    font-size:${props.theme.font.base};
    color:${props.theme.colors.grey.grey50};
    padding-bottom:${props.theme.spacing.small.s5};
  `
);

export const AmenitiesOuterWrap = styled.div(
  props => `
    width:100%;
    display: flex;
    flex-direction: column;
    padding-top: ${props.theme.spacing.base};
  `
)

export const TypeofAminitiesDiv = styled.div(
  props => `
    display:flex;
    flex-wrap: wrap;
    flex-direction: row;
    width:100%;
    padding-bottom:${props.theme.spacing.base};
    align-items: center;
  `
);

export const NonRefundableDiv = styled.div(
  props => `
    display:flex;
    flex-wrap: wrap;
    flex-direction: row;
    width:100%;
    padding-bottom:${props.theme.spacing.base};
    color: ${props.theme.colors.red.base};
    align-items: center;
  `
);

export const TickDiv = styled.span(
  props => `
    width:.6rem;
    height:.6rem;
    background-color: ${props.theme.colors.grey.base};
    border-radius: 50%;
    display: flex;
  `
);

export const FreeCancelDiv = styled(FreeCancelIcon)(
  props => `
    width:1.6rem;
    height:1.6rem;
    fill: ${props.theme.colors.green.base};
  `
);

export const TypeofAminitiestxtSpan = styled.span(
  props => `
    display:flex;
    flex-wrap: wrap;
    flex-direction: row;
    font-size:${props.theme.font.base};
    padding-left:${props.theme.spacing.small.s5};
    width:95%;
    color: ${props.color};
  `
);

export const ViewAllLink = styled.a(
  props => `
    display:inline-flex;
    cursor: pointer;
    font-size:${props.theme.font.base};
    color: ${props.theme.colors.goBrand.blue};
    &:hover{
      color: ${props.theme.colors.goBrand.blue};
    }
  `
);

export const FreeCancelTxtSpan = styled.p(
  props => `
    display:flex;
    flex-wrap: wrap;
    flex-direction: row;
    font-size:${props.theme.font.base};
    padding-left:${props.theme.spacing.small.s5};
    color:${props.theme.colors.green.base};
    font-weight: ${props.theme.font.fontWeight.black};
  `
);

export const FreeCancelOuterDiv = styled.div(
  prosp => `
    width:100%;
    display: flex;
  `
)

export const FreeCanelTickImgWrap = styled.div(
  props => `
    display: flex;
    padding-right: ${props.theme.spacing.small.s8};
  `
);

export const FreeCancelDateInfoText = styled.span(
  props => `
    font-size: ${props.theme.font.small.font11};
    color: ${props.theme.colors.grey.base1};
    font-weight: normal;
  `
)

export const CancelPolicyDiv = styled.div(
  props => `
    display:flex;
    flex-wrap: wrap;
    flex-direction: row;
    width:100%;
    padding-left:${props.theme.spacing.large.l20};
  `
);

export const CancelPolicyLink = styled.a(
  props => `
    display:inline-flex;
    cursor: pointer;
    font-size:${props.theme.font.base};

    color: ${props.theme.colors.goBrand.blue};
    &:hover{
      color: ${props.theme.colors.goBrand.blue};
    }
  `
);

export const CancellationPolicyList = styled.ul(
  props => `
    padding: ${props.theme.spacing.large.l20};
    border-top: 2px solid ${props.theme.colors.goBrand.bgBlue}
    list-style-type: none;
  `
);

export const CancellationPolicyListItem = styled.li(
  props => `
    padding: 0 0 ${props.theme.spacing.large.l15} 0;
    list-style-type:none;
  `
);

export const CancellationItemText = styled.span(
  props => `
    font-size: ${props.theme.font.large.font16};
    padding: 0 0 0 ${props.theme.spacing.base};
    position: relative;
    top: -3px;
  `
);

export const CancellationPolicyLoaderContainer = styled.div(
  props => `
    padding: ${props.theme.spacing.large.l15};
  `
);

export const CancellationPolicyListLoaderSmallItem = styled.li(
  props => `
    padding: 0 0 ${props.theme.spacing.large.l15} 0;
    list-style-type:none;
    background-color:${props.theme.colors.blue.lightBlue};
    border-radius:${props.theme.misc.borderRadius.small};
    width:30rem;
    margin-bottom :${props.theme.spacing.base};
  `
);

export const CancellationPolicyListLoaderLargeItem = styled.li(
  props => `
    padding: 0 0 ${props.theme.spacing.large.l15} 0;
    list-style-type:none;
    background-color:${props.theme.colors.blue.lightBlue};
    border-radius:${props.theme.misc.borderRadius.small};
    width:40rem;
    margin-bottom :${props.theme.spacing.base};
  `
);

export const PolicyContentContainer = styled.div(
  props => `
    display:flex;
    flex-direction: column;
    width:100%;
    max-height: 80vh;
    overflow: auto;
  `
);
